import React from 'react';
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';

import * as styles from 'src/uglib_styles/studySpaceList.module.css'

import { get_optional_field} from 'src/uglib_utils/utils'
import StudySpacesListHeader from './studySpacesListHeader';

function StudySpaceList () {

    const data = useStaticQuery(graphql`
      query StudySpaceQuery {
        spaces: allNodeStudySpace(sort: {title: ASC}) {
          nodes {
            title
            path {
              alias
            }
            drupal_id
            id
            field_study_space_booking_link {
              uri
            }
            field_study_space_capacity
            field_study_space_image {
              height
              title
              width
            }
            field_study_space_location {
              processed
            }
            field_study_space_more_info {
              processed
            }
            field_study_space_availability
            relationships {
              field_study_space_image {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
              field_study_space_tags {
                name
              }
            }
          }
        }
      }
    `)

    let spaces = data.spaces.nodes;

    const rendered_spaces = spaces.map((space) => {
      
        const features = space.relationships.field_study_space_tags.map((tag) => tag.name).join(", ");

        const availability_options = {
            'anyone': 'Anyone',
            'undergraduate': 'Undergraduate students',
            'graduate': 'Graduate students',
            'las': 'Student Accessibility Services (SAS) students',
            'faculty_staff': 'Faculty and staff'
        }

        const availability = availability_options[space.field_study_space_availability];

        let booking_button = <></>;
        const booking_link = get_optional_field(space, 'field_study_space_booking_link.uri');
        
        // Booking link
        if(booking_link !== null) {
            booking_button = <>
                <div className={"text-center " + styles.button}>
                    <a className="btn btn-outline-info" href={booking_link}>
                        <span className="far fa-calendar icon" />
                        Book &nbsp;
                        <span className="sr-only">{space.title}</span>
                        Now
                    </a>
                </div>
            </>
        }

        // More info
        let more_info = <></>;
        const more_info_value = get_optional_field(space, 'field_study_space_more_info.processed');
        
        if (more_info_value !== null) {
            more_info = <div className={[styles.field, styles.more_info].join(' ')}>
                <span className={styles.label + " sr-only"}>More info:</span>
                <span className="value" dangerouslySetInnerHTML={{__html: more_info_value}} />
            </div>
        }
       
        // Render each space
        return (
            <li className={"space " + styles.space_wrapper}>
                <GatsbyImage className="image" image={space.relationships.field_study_space_image.localFile.childImageSharp.gatsbyImageData} alt="" placeholder="blurred" />
                <h3 className={styles.title}>{space.title}</h3>
                <div className={styles.field}>
                    <span className={styles.label}>Availability:</span>
                    <span className="value">{availability}</span>
                </div>

                <div className={"field-features " + styles.field}>
                    <span className={styles.label}>Features: </span>
                    <span className="value">{features}</span>
                </div>

                <div className={styles.field}>
                    <span className={styles.label}>Location: </span>
                    <span className="value" dangerouslySetInnerHTML={{__html: space.field_study_space_location.processed}} />
                </div>

                {more_info}

                {booking_button}

                <span className="data" data-amenities={features} data-occupancy={space.field_study_space_capacity} />
            </li>
        )
    })
    
    return (<>
        <h2>Study Spaces</h2>
        <StudySpacesListHeader />
        <ul aria-live="polite" id="spaces-list" className={styles.spaces_list}>
            {rendered_spaces}
        </ul>
    </>);
    
}

StudySpaceList.propTypes = {
	category: PropTypes.string,
}

StudySpaceList.defaultProps = {
    category: "General"
}

export default StudySpaceList